var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignaturePad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.369,
    height: 10.278,
    viewBox: "0 0 15.369 10.278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_touch-screen_22825",
    transform: "translate(0 -0.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8911",
    "data-name": "Path 8911",
    d: "M25.1,9.573c-.788-.021-1.562.283-2.351.247a1.138,1.138,0,0,1-.239-.063,1.455,1.455,0,0,1,.241-.277,13.588,13.588,0,0,1,1.858-1.3c.443-.3.764-1,.095-1.251a2.024,2.024,0,0,0-.99,0,8.011,8.011,0,0,0-1.312.314,9.55,9.55,0,0,0-1.782.773c-.389.22-.963.564-.857,1.091.053.265.421.225.5,0,.039-.117.327-.236.422-.29a7.406,7.406,0,0,1,.677-.322,11.241,11.241,0,0,1,1.911-.656,6.2,6.2,0,0,1,.61-.121c-.206.141-.414.28-.617.426-.469.337-1.539.992-1.349,1.7.11.412.7.41,1.024.386a8.645,8.645,0,0,0,.985-.176,4.651,4.651,0,0,0,1.229-.292C25.248,9.713,25.2,9.575,25.1,9.573Z",
    transform: "translate(-16.701 -5.425)",
    fill: "#505f7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8912",
    "data-name": "Path 8912",
    d: "M15.369,5.413V1.423a.978.978,0,0,0-.978-.978H.978A.978.978,0,0,0,0,1.423v5.13a.978.978,0,0,0,.978.978h5.4V7.145H1.218V.833L13.826.788V7.531h.565a.978.978,0,0,0,.975-.9Z",
    fill: "#505f7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8913",
    "data-name": "Path 8913",
    d: "M46.378,21.083a.516.516,0,0,1,.514-.514h.023a.516.516,0,0,1,.514.514l.028,1.869a.515.515,0,0,1,.514-.514h.023a.516.516,0,0,1,.514.514v.322a.515.515,0,0,1,.514-.514h.023a.516.516,0,0,1,.514.514v.514a.515.515,0,0,1,.514-.514H50.1a.515.515,0,0,1,.514.514V25.53a2.363,2.363,0,0,1-2.332,2.207c-1.409,0-1.869-1.171-2.229-1.58s-1.606-1.316-1.606-1.654.262-.415.492-.415c.612,0,1.441.81,1.441.81Z",
    transform: "translate(-37.575 -17.014)",
    fill: "#505f7b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignaturePad);
export default __webpack_public_path__ + "static/media/signaturePad.affd1241.svg";
export { ForwardRef as ReactComponent };